// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-edit-pen',
    // #endregion
    // #region Events
    emits: ["click"],
    // #endregion        
});
// #endregion
